import { gql } from '@apollo/client';

export type SaveTtPresortConfigInput = {
  id?: number;
  fromCode: string;
  nextStopCode: string;
  carrierCode: string;
  ttBizType: string;
  presortCode: string;
  mappedSortingCode?: string | null;
  labelCode?: string | null;
  sortOrder?: number | null;
};

export const SAVE_TT_PRESORT_CONFIG = gql`
  mutation SaveTtPresortConfig($input: SaveTtPresortConfigInput!) {
    saveTtPresortConfig(input: $input) {
      id
      presortCode
    }
  }
`;

export const DELETE_TT_PRESORT_CONFIG = gql`
  mutation DeleteTtPresortConfig($id: Long!) {
    deleteTtPresortConfig(id: $id)
  }
`;
